import { Pipe, PipeTransform } from '@angular/core';

/**
 * Beispiel:
 * {"d41c43b1-1bc3-4ba7-954d-d2068e13239a": {
 *      field1: value1,
 *      field2: value2,
 *      ....
 *      fieldN: valueN
 * }}
 *
 * "hashToArray:'fieldX'"  =>
 *
 * [{fieldX: d41c43b1-1bc3-4ba7-954d-d2068e13239a, field1: value1, field2: value2, ..., fieldN: valueN}]
 */
@Pipe({
    name: 'hashToArray'
})
export class HashToArrayPipe<T> implements PipeTransform {
    transform(value: { [index: string]: T }, indexName: string) {
        return Object.keys(value).map(key => {
            const result = value[key];
            result[indexName] = key;
            return result;
        });
    }
}
